@if(activeNavPoint && activeNavPoint !== NavigationPoint.login && activeNavPoint !== NavigationPoint.home && activeNavPoint !== NavigationPoint.userAdmin) {
    <div class="badge-anim-div" [ngClass]="{'show': badges && badges.length > 0 || textSearchBade || skuSearchBadge}">
        @if(badges && badges.length > 0 || textSearchBade || skuSearchBadge) {
            <div class="badge-wrapper">
                <div class="badges-bar">
                    @if(textSearchBade) {
                        <span class="badge">
                        <mat-icon fontIcon="disabled_by_default" (click)="clearTextSearchBade()"></mat-icon>
                    <span class="value">{{textSearchBade.value}}</span>
                </span>
                    }
                    @if(skuSearchBadge) {
                        <span class="badge">
                        <mat-icon fontIcon="disabled_by_default" (click)="clearSkuSearchBade()"></mat-icon>
                    <span class="value">{{skuSearchBadge.value}}</span>
                </span>
                    }
                    @for (badge of badges; track badge) {
                        <span class="badge">
                        <mat-icon fontIcon="disabled_by_default" (click)="removeFilter(badge)"></mat-icon>
                            @if(badge.translateKey) {
                                <span class="value">{{ badge.translateKey | translate}}</span>
                            }

                        </span>
                    }

                </div>
                <div class="actions">
                    <button type='button' mat-stroked-button (click)="clearAllFilters()"><mat-icon fontIcon="filter_list_off"></mat-icon>{{'clearAllFilters' | translate}}</button>
                    @if(user && user.effectiveRoles && user.effectiveRoles.ROLE_ADMIN_ACCESS) {
                        <button type='button' (click)="copyQueryParams()" mat-raised-button class="primary">Copy Params</button>
                    }
                </div>
            </div>
        }
    </div>
}


